import moment from "moment"
import { URL } from "../store/actions/depannageActions"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import {
	faChevronLeft,
	faChevronRight,
} from "@fortawesome/free-solid-svg-icons"
import React from "react"
import { LOCATION_ETAT_RESERVATION } from "./Constants"

// Source de vérité unique = package.json (champ "version"), injecté au build
// via REACT_APP_VERSION (cf. scripts npm). Bump avec `npm version patch|minor`.
// REACT_APP_GIT_SHA donne la provenance du build (SHA court). Fallback "dev"
// si lancé hors des scripts npm.
export const APP_VERSION = process.env.REACT_APP_VERSION || "dev"
export const APP_GIT_SHA = process.env.REACT_APP_GIT_SHA || ""

export const MONTHS = [
	"-",
	"Janvier",
	"Février",
	"Mars",
	"Avril",
	"Mai",
	"Juin",
	"Juillet",
	"Août",
	"Septembre",
	"Octobre",
	"Novembre",
	"Décembre",
]
export const YEARS = [
	"-",
	...Array.from(
		{ length: parseInt(moment().format("YYYY")) - 2018 },
		(v, k) => k + 2020,
	),
]

export const PROPRE_VEHICULE_TYPE_DEPANNAGE = 0
export const PROPRE_VEHICULE_TYPE_LOCATION = 1
// Valeur 2 historiquement "Outil" — conservée, relabellisée en "Autre".
export const PROPRE_VEHICULE_TYPE_AUTRE = 2
export const PROPRE_VEHICULE_TYPE_CHOICES = [
	[PROPRE_VEHICULE_TYPE_DEPANNAGE, "Dépannage"],
	[PROPRE_VEHICULE_TYPE_LOCATION, "Location"],
	[PROPRE_VEHICULE_TYPE_AUTRE, "Autre"],
]

export const PROPRE_VEHICULE_STATUS_FONCTIONNEL = 0
export const PROPRE_VEHICULE_STATUS_ACCIDENTE = 1
export const PROPRE_VEHICULE_STATUS_EN_REPARATION = 2
export const PROPRE_VEHICULE_STATUS_CHOICES = [
	[PROPRE_VEHICULE_STATUS_FONCTIONNEL, "Fonctionnel"],
	[PROPRE_VEHICULE_STATUS_ACCIDENTE, "Accidenté"],
	[PROPRE_VEHICULE_STATUS_EN_REPARATION, "En réparation"],
]

export const DEP_TYPE_INTERVENTION = 0
export const DEP_TYPE_TRANSPORT = 1
export const DEP_TYPE = {
	0: "Intervention",
	1: "Transport",
}
export const DEP_TYPE_LIST = [
	{ id: DEP_TYPE_TRANSPORT, label: "Transport" },
	{ id: DEP_TYPE_INTERVENTION, label: "Intervention" },
]

// Type d'appel (aligné sur DepMission.appel_type). Le libellé UI du 1er choix
// est « Assistance » (le champ historique s'appelle « assurance » mais l'entité
// donneuse d'ordre est une assistance). SOURCE UNIQUE côté front (miroir de
// svp/constants.py) — remplace les exports locaux de DepMissionV2.js.
export const DEPANNAGE_TYPE_APPEL_ASSISTANCE = 0
export const DEPANNAGE_TYPE_APPEL_POLICE = 1
export const DEPANNAGE_TYPE_APPEL_PRIVE = 2
export const DEPANNAGE_TYPE_APPEL_CHOICES = [
	[DEPANNAGE_TYPE_APPEL_ASSISTANCE, "Assistance"],
	[DEPANNAGE_TYPE_APPEL_POLICE, "Police"],
	[DEPANNAGE_TYPE_APPEL_PRIVE, "Privé"],
]
// Défaut métier : un dépannage saisi directement (sans mission amont) est privé.
export const DEPANNAGE_TYPE_APPEL_DEFAULT = DEPANNAGE_TYPE_APPEL_PRIVE

export const DIAGNOSTIQUE_POLICE_LABELS = {
	1: "À vide",
	2: "Disponible",
	3: "Fourrière",
	4: "Séquestre",
}

// Encodage RÉEL en base (les `choices` du modèle DepMission mentent) :
// clé 0 non renseigné / 1 avec / 2 sans ; accident 0 unset / 1 accident / 2 enlèvement.
export const CLE_AVEC = 1
export const CLE_SANS = 2
export const ACCIDENT = 1
export const ENLEVEMENT = 2

// États de la FICHE dépannage (cycle de vie, ≠ DEP_STATE_* des missions de
// dispatch). SOURCE UNIQUE front, miroir de DEPANNAGE_ETAT_* (svp/constants.py).
// Le pipeline compta (40/50/60/70) reprend les valeurs de l'atelier.
export const DEPANNAGE_ETAT_EN_COURS = 0
export const DEPANNAGE_ETAT_EN_ATELIER = 20
export const DEPANNAGE_ETAT_CONTROLE_AVANT_FACTURATION = 40
export const DEPANNAGE_ETAT_OK_POUR_FACTURATION = 50
export const DEPANNAGE_ETAT_EN_ATTENTE_PAIEMENT = 60
export const DEPANNAGE_ETAT_CLOS = 70
export const DEPANNAGE_ETAT_ANNULE = 80
export const DEPANNAGE_ETAT_CHOICES = [
	// « Ouverte » (et non « En cours ») : le mot est réservé à cet état du
	// pipeline, pour ne pas le confondre avec une fiche VERROUILLÉE (quelqu'un
	// est dessus). Miroir exact de svp/constants.py — valeur 0 inchangée.
	[DEPANNAGE_ETAT_EN_COURS, "Ouverte"],
	[DEPANNAGE_ETAT_EN_ATELIER, "En atelier"],
	[DEPANNAGE_ETAT_CONTROLE_AVANT_FACTURATION, "Contrôle avant facturation"],
	[DEPANNAGE_ETAT_OK_POUR_FACTURATION, "Ok pour facturation"],
	[DEPANNAGE_ETAT_EN_ATTENTE_PAIEMENT, "En attente de paiement"],
	[DEPANNAGE_ETAT_CLOS, "Clos"],
	[DEPANNAGE_ETAT_ANNULE, "Annulé"],
]
export const DEPANNAGE_ETAT_DICT = Object.fromEntries(DEPANNAGE_ETAT_CHOICES)
// Couleurs badge par état (même idiome que ETAT_BADGE du dispatch).
// Miroir de Depannage.ETAT_TRANSITIONS (backend/svp/models.py) : états
// atteignables depuis l'état enregistré (menu des états, Jordan 30.10). Le
// serveur reste la référence (assert_etat_transition, assert_cloture,
// réouverture boss seul).
export const DEPANNAGE_ETAT_TRANSITIONS = {
	[DEPANNAGE_ETAT_EN_COURS]: [
		DEPANNAGE_ETAT_EN_ATELIER,
		DEPANNAGE_ETAT_CONTROLE_AVANT_FACTURATION,
		DEPANNAGE_ETAT_ANNULE,
	],
	[DEPANNAGE_ETAT_EN_ATELIER]: [
		DEPANNAGE_ETAT_EN_COURS,
		DEPANNAGE_ETAT_CONTROLE_AVANT_FACTURATION,
		DEPANNAGE_ETAT_ANNULE,
	],
	[DEPANNAGE_ETAT_CONTROLE_AVANT_FACTURATION]: [
		DEPANNAGE_ETAT_OK_POUR_FACTURATION,
		DEPANNAGE_ETAT_EN_COURS,
		DEPANNAGE_ETAT_ANNULE,
	],
	// Jordan 30.10 : Facturer peut clore directement (règle de clôture).
	[DEPANNAGE_ETAT_OK_POUR_FACTURATION]: [
		DEPANNAGE_ETAT_CLOS,
		DEPANNAGE_ETAT_EN_ATTENTE_PAIEMENT,
		DEPANNAGE_ETAT_CONTROLE_AVANT_FACTURATION,
		DEPANNAGE_ETAT_ANNULE,
	],
	[DEPANNAGE_ETAT_EN_ATTENTE_PAIEMENT]: [
		DEPANNAGE_ETAT_CLOS,
		DEPANNAGE_ETAT_OK_POUR_FACTURATION,
		DEPANNAGE_ETAT_EN_COURS,
		DEPANNAGE_ETAT_ANNULE,
	],
	[DEPANNAGE_ETAT_CLOS]: [DEPANNAGE_ETAT_EN_ATTENTE_PAIEMENT],
	[DEPANNAGE_ETAT_ANNULE]: [DEPANNAGE_ETAT_EN_COURS],
}

export const DEPANNAGE_ETAT_BADGE = {
	[DEPANNAGE_ETAT_EN_COURS]: { color: "#0E7490", bg: "#CFFAFE" },
	[DEPANNAGE_ETAT_EN_ATELIER]: { color: "#B45309", bg: "#FEF3C7" },
	[DEPANNAGE_ETAT_CONTROLE_AVANT_FACTURATION]: {
		color: "#6D28D9",
		bg: "#EDE9FE",
	},
	[DEPANNAGE_ETAT_OK_POUR_FACTURATION]: { color: "#1D4ED8", bg: "#DBEAFE" },
	[DEPANNAGE_ETAT_EN_ATTENTE_PAIEMENT]: { color: "#7C2D12", bg: "#FFEDD5" },
	[DEPANNAGE_ETAT_CLOS]: { color: "#166534", bg: "#DCFCE7" },
	[DEPANNAGE_ETAT_ANNULE]: { color: "#B91C1C", bg: "#FEE2E2" },
}

// E-mails (GE-25). Plus rien d'exclusif à l'atelier : la file est générique
// atelier/dépannage, et les « part_types » ont disparu au profit d'une
// sélection explicite de documents (proposés ⇔ leur fichier existe).
export const EMAIL_STATUS_READY_TO_SEND = 0
export const EMAIL_STATUS_SENT = 1
export const EMAIL_STATUS_ERROR = 2
// Claim anti double-envoi posé par SvpCentral pendant l'envoi SMTP ; un e-mail
// resté dans cet état après un crash est repassé en Échec « vérifier
// réception » au run suivant.
export const EMAIL_STATUS_SENDING = 3

export const EMAIL_DESTINATAIRE_CLIENT_SOCIETE = 0
export const EMAIL_DESTINATAIRE_CLIENT_PERSONNE = 1
export const EMAIL_DESTINATAIRE_ASSURANCE = 2
export const EMAIL_DESTINATAIRE_EXPERT = 3
export const EMAIL_DESTINATAIRE_SOUS_TRAITANT = 4
export const EMAIL_DESTINATAIRE_LIBRE = 5
export const EMAIL_DESTINATAIRE_CONDUCTEUR = 6
export const EMAIL_DESTINATAIRE_CHOICES = [
	[EMAIL_DESTINATAIRE_CLIENT_SOCIETE, "Client société"],
	[EMAIL_DESTINATAIRE_CLIENT_PERSONNE, "Client personne physique"],
	[EMAIL_DESTINATAIRE_ASSURANCE, "Assurance"],
	[EMAIL_DESTINATAIRE_EXPERT, "Expert"],
	[EMAIL_DESTINATAIRE_SOUS_TRAITANT, "Sous-traitant"],
	[EMAIL_DESTINATAIRE_LIBRE, "Libre"],
	[EMAIL_DESTINATAIRE_CONDUCTEUR, "Conducteur"],
]
export const EMAIL_DESTINATAIRE_DICT = Object.fromEntries(
	EMAIL_DESTINATAIRE_CHOICES,
)

export const DEP_STATE_CREATION = 0
export const DEP_STATE_CHECK_DATA = 10
export const DEP_STATE_READY_TO_DISPATCH = 20
export const DEP_STATE_EN_SUSPENS = 23
export const DEP_STATE_EN_ATTENTE = 25
export const DEP_STATE_RENDEZ_VOUS = 27
export const DEP_STATE_DISPATCHED = 30
export const DEP_STATE_ACCEPTED = 40
export const DEP_STATE_ONGOING = 50
export const DEP_STATE_DONE = 60
export const DEP_STATE_TRANSFERRED = 70
export const DEP_STATE_CANCELED = 80
export const DEP_STATES = {
	0: "Création",
	10: "À vérifier", // A15 : un seul libellé pour l'état 10
	20: "Prêt au dispatch",
	23: "En suspens",
	25: "En attente",
	27: "Rendez-vous",
	30: "Dispatché",
	40: "Accepté",
	50: "En cours",
	60: "Terminé",
	70: "Transféré",
	80: "Annulée",
}

export const ATELIER_ETAT_DEVIS_A_FAIRE = -1
export const ATELIER_ETAT_DEVIS = 0
export const ATELIER_ETAT_EN_ATTENTE_CLIENT = 10
export const ATELIER_ETAT_DEVIS_REFUSE = 12
export const ATELIER_ETAT_DEVIS_ACCEPTE = 15
export const ATELIER_ETAT_TRAVAUX_EN_COURS = 20
export const ATELIER_ETAT_TRAVAUX_TERMINES = 25
export const ATELIER_ETAT_A_RESTITUER = 30
export const ATELIER_ETAT_CONTROLE_AVANT_FACTURATION = 40
export const ATELIER_ETAT_OK_POUR_FACTURATION = 50
export const ATELIER_ETAT_EN_ATTENTE_PAIEMENT = 60
export const ATELIER_ETAT_CLOS = 70
export const ATELIER_ETATS_CHOICES = [
	[ATELIER_ETAT_DEVIS_A_FAIRE, "Devis à faire"],
	[ATELIER_ETAT_DEVIS, "Devis"],
	[ATELIER_ETAT_EN_ATTENTE_CLIENT, "En attente client"],
	[ATELIER_ETAT_DEVIS_REFUSE, "Devis refusé"],
	[ATELIER_ETAT_DEVIS_ACCEPTE, "Devis accepté"],
	[ATELIER_ETAT_TRAVAUX_EN_COURS, "Travaux en cours"],
	[ATELIER_ETAT_TRAVAUX_TERMINES, "Travaux terminés"],
	[ATELIER_ETAT_A_RESTITUER, "A restituer"],
	[ATELIER_ETAT_CONTROLE_AVANT_FACTURATION, "Contrôle avant facturation"],
	[ATELIER_ETAT_OK_POUR_FACTURATION, "Ok pour facturation"],
	[ATELIER_ETAT_EN_ATTENTE_PAIEMENT, "En attente de paiement"],
	[ATELIER_ETAT_CLOS, "Clos"],
]
export const ATELIER_ETATS_SVP_CHOICES = [
	[ATELIER_ETAT_TRAVAUX_EN_COURS, "Travaux en cours"],
	[ATELIER_ETAT_TRAVAUX_TERMINES, "Travaux terminés"],
	[ATELIER_ETAT_CLOS, "Clos"],
]

export const complementAdresseToListString = (adresse) => {
	return [
		`${adresse.rue} ${adresse.numero}`,
		`${adresse.code_postal} ${adresse.localite}`,
	]
}

export function formatNumber(number) {
	const formatted = Number(number).toLocaleString("fr-CH", {
		minimumFractionDigits: 2,
		maximumFractionDigits: 2,
	})
	return formatted.replace(/\s/g, "'")
}

export function isValidEmail(email) {
	const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/
	return regex.test(email)
}

export function resizeImage(w, h, maxw, maxh) {
	if (w > maxw && h <= maxh)
		return { width: maxw, height: parseInt((maxw / w) * h) }
	else if (h > maxh && w <= maxw)
		return { width: parseInt((maxh / h) * w), height: maxh }
	else if (h > maxh && w > maxw) {
		if (h / maxh >= w / maxw)
			return { width: parseInt((maxh / h) * w), height: maxh }
		else return { width: maxw, height: parseInt((maxw / w) * h) }
	} else return { width: w, height: h }
}

export function bytesToHuman(number) {
	if (number >= 1000000) return `${round100(number / 1000000)} Mo`
	else return `${round100(number / 1000)} Ko`
}

export function getStrForTable(str, maxLength) {
	if (str.length > maxLength) return `${str.substring(0, maxLength)}...`
	else return str
}

export function getMdpTot(mdps, id, tot) {
	let m = mdps.find((mdp) => mdp.id === id)
	if (m !== undefined) {
		if (m.apply) {
			if (m.isMult === 1)
				return round100((parseFloat(tot) * m.value) / 100)
			else return round100(parseFloat(m.value))
		}
	}
	return 0
}

export function isEmpty(obj) {
	for (let key in obj) {
		if (obj.hasOwnProperty(key)) return false
	}
	return true
}

export function isEquivalent(a, b) {
	let aProps = Object.getOwnPropertyNames(a)
	let bProps = Object.getOwnPropertyNames(b)

	if (aProps.length !== bProps.length) {
		return false
	}

	for (let i = 0; i < aProps.length; i++) {
		let propName = aProps[i]
		if (a[propName] !== b[propName]) {
			return false
		}
	}
	return true
}

export async function postDep(data, loading, closing, token) {
	await loading()
	const dep = await fetch(`${URL}api/depannages`, {
		method: "post",
		headers: {
			Accept: "application/json, text/plain",
			"Content-type": "application/json",
			Authorization: `Bearer ${token}`,
		},
		body: data,
	}).then((res) => res.json())
	await closing()
	return dep
}

export function typeRef(e, nextRef, withSlash = false) {
	let format = withSlash ? /^[a-z0-9]+\/?[a-z0-9]*$/i : /^[a-z0-9]*$/i
	let str = e.target.value + e.key
	if (e.key === "Enter" && nextRef) nextRef.current.focus()
	if (
		format.test(str) ||
		e.key === "Backspace" ||
		e.key === "Enter" ||
		e.key === "ArrowLeft" ||
		e.key === "ArrowRight" ||
		e.key === "Delete" ||
		e.key === "Control"
	)
		return
	else e.preventDefault()
}

export function typeNumber(e) {
	let numberFormat = /^[0-9]+\.?[0-9]*$/
	let str = e.target.value + e.key
	if (
		numberFormat.test(str) ||
		e.key === "Backspace" ||
		e.key === "Enter" ||
		e.key === "ArrowLeft" ||
		e.key === "ArrowRight" ||
		e.key === "Delete"
	)
		return
	else e.preventDefault()
}

// GE-71 : comme typeNumber, avec un « - » en tête (montant négatif = rabais).
// Réservé aux lignes Autres de la fiche dépannage — typeNumber reste positif
// partout ailleurs.
export function typeNumberSigned(e) {
	const input = e.target
	const debut = input.selectionStart ?? input.value.length
	const fin = input.selectionEnd ?? input.value.length
	const str = input.value.slice(0, debut) + e.key + input.value.slice(fin)
	if (
		/^-?[0-9]*\.?[0-9]*$/.test(str) ||
		e.key === "Backspace" ||
		e.key === "Enter" ||
		e.key === "ArrowLeft" ||
		e.key === "ArrowRight" ||
		e.key === "Delete" ||
		e.key === "Tab"
	)
		return
	else e.preventDefault()
}

export function typeNumberAndNext(e, nextRef) {
	let numberFormat = /^[0-9]+\.{0,1}[0-9]*$/
	let str = e.target.value + e.key
	if (
		numberFormat.test(str) ||
		e.key === "Backspace" ||
		e.key === "ArrowLeft" ||
		e.key === "ArrowRight" ||
		e.key === "Delete"
	)
		return
	else if (e.key === "Enter") nextRef.current.focus()
	else e.preventDefault()
}

export function typeIntAndNext(e, nextRef) {
	if (["0", "1", "2", "3", "4", "5", "6", "7", "8", "9"].includes(e.key))
		return
	else if (
		e.key === "Backspace" ||
		e.key === "ArrowLeft" ||
		e.key === "ArrowRight" ||
		e.key === "Delete"
	)
		return
	else if (e.key === "Enter" && nextRef) nextRef.current.focus()
	else e.preventDefault()
}

export function isNumber(e) {
	let numberFormat = /^[0-9]+\.{0,1}[0-9]*$/
	let str = e.target.value + e.key
	if (
		numberFormat.test(str) ||
		e.key === "Backspace" ||
		e.key === "Enter" ||
		e.key === "ArrowLeft" ||
		e.key === "ArrowRight"
	)
		return str
	else return false
}

export const renderPagination = (_pagination, _onClick) => {
	return (
		<div className="row flex-center no-user-select">
			{_pagination.first !== null ? (
				<button
					type={"button"}
					className={"norm-btn"}
					onClick={() =>
						_onClick(
							_pagination.first.limit,
							_pagination.first.offset,
						)
					}
				>
					<FontAwesomeIcon icon={faChevronLeft} />
				</button>
			) : (
				<div style={{ width: 40 }} />
			)}
			{_pagination.previous !== null ? (
				<button
					type={"button"}
					className={"norm-btn"}
					onClick={() =>
						_onClick(
							_pagination.previous.limit,
							_pagination.previous.offset,
						)
					}
				>
					{_pagination.current - 1}
				</button>
			) : (
				<div style={{ width: 40 }} />
			)}
			<button
				type={"button"}
				className={"norm-btn"}
				onClick={() => {}}
				disabled={true}
			>
				{_pagination.current}
			</button>
			{_pagination.next !== null ? (
				<button
					type={"button"}
					className={"norm-btn"}
					onClick={() =>
						_onClick(
							_pagination.next.limit,
							_pagination.next.offset,
						)
					}
				>
					{_pagination.current + 1}
				</button>
			) : (
				<div style={{ width: 40 }} />
			)}
			{_pagination.last !== null ? (
				<button
					type={"button"}
					className={"norm-btn"}
					onClick={() =>
						_onClick(
							_pagination.last.limit,
							_pagination.last.offset,
						)
					}
				>
					<FontAwesomeIcon icon={faChevronRight} />
				</button>
			) : (
				<div style={{ width: 40 }} />
			)}
		</div>
	)
}

export function getParams(params) {
	let url = "?"
	for (let [key, val] of Object.entries(params)) url += `${key}=${val}&`
	return url.slice(0, -1)
}

export function round100(value) {
	if (isNaN(value)) return 0
	else return Math.round(value * 100) / 100
}

export function round20(value) {
	if (isNaN(value)) return 0
	return Math.round(value * 20) / 20
}

export function HTtoTTC(value, tva) {
	return value * (tva / 100 + 1)
}

export function TTCtoHT(value, tva) {
	return value / (tva / 100 + 1)
}

export function nextRef(e, nextRef) {
	if (e.key === "Enter" && nextRef) nextRef.current.focus()
}

export function nextRefPreventDefault(e, nextRef) {
	if (e.key === "Enter") {
		e.preventDefault()
		nextRef.current.focus()
	}
}

export function onEnter(e, func) {
	if (e.key === "Enter") func()
}

export function isValidDate(arg) {
	let date = moment(arg, "DD-MM-YYYY", true)
	return date._isValid
}

// Date du jour au format ISO (YYYY-MM-DD), format attendu par les inputs date V2.
export function todayISO() {
	return moment().format("YYYY-MM-DD")
}

export function isValidDateUSA(arg) {
	let date = moment(arg, "YYYY-MM-DD", true)
	return date._isValid
}

export function isValidTime(arg) {
	let time = moment(arg, "kk:mm", true)
	return time._isValid
}

export function isValidDateTime(arg) {
	let time = moment(arg, "DD-MM-YYYY kk:mm", true)
	return time._isValid
}

export function typeHeure(e, nextRef, update, field) {
	let heureFormat = /^[0-9]$/
	let chars = ["Backspace", "Enter", "Delete", "ArrowLeft", "ArrowRight"]
	if (e.key.match(heureFormat) || chars.includes(e.key)) {
		let input = e.target.value
		if (e.key.match(heureFormat)) input += e.key
		switch (e.key) {
			case "Backspace":
				break
			case "Enter":
				if (nextRef !== null) {
					e.preventDefault()
					nextRef.current.focus()
				}
				break
			case "ArrowLeft":
				break
			case "ArrowRight":
				break
			default:
				e.preventDefault()
				let caretS = e.target.selectionStart
				let caretE = e.target.selectionEnd
				if (caretS !== caretE && caretS !== 0 && caretE !== 5) {
				} else if (caretS === caretE) {
					if (input.length === 2 && caretE === 1) {
						input += ":"
						e.target.value = input
					} else if (input.length === 3 && caretE === 2) {
						input = input.substring(0, 2) + ":" + input[2]
						e.target.value = input
					} else if (input.length > 4 && nextRef !== null) {
						nextRef.current.focus()
					} else {
						input =
							e.target.value.substring(0, caretS) +
							e.key +
							e.target.value.substring(caretS)
						e.target.value = input
						e.target.setSelectionRange(caretS + 1, caretS + 1)
					}
				}
				if (caretS === 0 && caretE === 5) {
					e.target.value = e.key
					break
				} else if (input.length > 5) {
				} else {
					e.target.value = input
				}
				update(field, e)
		}
	} else {
		e.preventDefault()
	}
}

export function typeDateSearch(e, nextRef, search) {
	let chars = [
		"Backspace",
		"Enter",
		"Delete",
		"ArrowLeft",
		"ArrowRight",
		"+",
		"-",
	]
	let dateFormat = /^[0-9]$/
	if (e.key.match(dateFormat) || chars.includes(e.key)) {
		let input = e.target.value
		let d
		if (e.key.match(dateFormat)) input += e.key
		switch (e.key) {
			case "Backspace":
				break
			case "Enter":
				if (nextRef !== null) nextRef.current.focus()
				else search()
				break
			case "ArrowLeft":
				break
			case "ArrowRight":
				break
			case "Delete":
				break
			case "+":
				e.preventDefault()
				if (isValidDate(e.target.value)) {
					d = moment(e.target.value, "DD-MM-YYYY")
						.add(1, "days")
						.format("DD-MM-YYYY")
					e.target.value = d
					if (nextRef !== null) nextRef.current.value = d
				} else {
					d = moment().format("DD-MM-YYYY")
					e.target.value = d
					if (nextRef !== null)
						nextRef.current.value = e.target.value = d
				}
				break
			case "-":
				e.preventDefault()
				if (isValidDate(e.target.value)) {
					d = moment(e.target.value, "DD-MM-YYYY")
						.add(-1, "days")
						.format("DD-MM-YYYY")
					e.target.value = d
					if (nextRef !== null) nextRef.current.value = d
				} else {
					d = moment().format("DD-MM-YYYY")
					e.target.value = d
					if (nextRef !== null)
						nextRef.current.value = e.target.value = d
				}
				break
			default:
				e.preventDefault()
				let caretS = e.target.selectionStart
				let caretE = e.target.selectionEnd
				if (caretS !== caretE && caretS !== 0 && caretE !== 10) {
				} else if (caretS === caretE) {
					if (input.length === 2 && caretE === 1) {
						input += "-"
						e.target.value = input
					} else if (input.length === 3 && caretE === 2) {
						input = input.substring(0, 2) + "-" + input[2]
						e.target.value = input
					} else if (input.length === 5 && caretE === 4) {
						input += "-" + new Date().getFullYear()
						e.target.value = input
						if (nextRef !== null) nextRef.current.focus()
					} else if (input.length === 6 && caretE === 5) {
						input =
							input.substring(0, 5) +
							"-" +
							input[5] +
							new Date().getFullYear()
						e.target.value = input
						if (nextRef !== null) nextRef.current.focus()
					} else if (input.length > 10) {
					} else {
						input =
							e.target.value.substring(0, caretS) +
							e.key +
							e.target.value.substring(caretS)
						e.target.value = input
						e.target.setSelectionRange(caretS + 1, caretS + 1)
					}
				} else if (caretS === 0 && caretE === 10) {
					e.target.value = e.key
				} else if (input.length > 10) {
				} else {
					e.target.value = input
				}
		}
	} else {
		e.preventDefault()
	}
}

export function typeDateSearchUpdate(
	e,
	nextRef,
	search,
	update,
	field,
	specialUpdate,
) {
	let chars = [
		"Backspace",
		"Enter",
		"Delete",
		"ArrowLeft",
		"ArrowRight",
		"+",
		"-",
	]
	let dateFormat = /^[0-9]$/
	if (e.key.match(dateFormat) || chars.includes(e.key)) {
		let input = e.target.value
		let d
		if (e.key.match(dateFormat)) input += e.key
		switch (e.key) {
			case "Backspace":
				break
			case "Enter":
				if (nextRef !== null) nextRef.current.focus()
				else search()
				break
			case "ArrowLeft":
				break
			case "ArrowRight":
				break
			case "Delete":
				break
			case "+":
				e.preventDefault()
				if (isValidDate(e.target.value)) {
					d = moment(e.target.value, "DD-MM-YYYY")
						.add(1, "days")
						.format("DD-MM-YYYY")
					if (nextRef !== null) specialUpdate(d)
					else update("dateF", { target: { value: d } })
				} else {
					d = moment().format("DD-MM-YYYY")
					if (nextRef !== null) specialUpdate(d)
					else update("dateF", { target: { value: d } })
				}
				break
			case "-":
				e.preventDefault()
				if (isValidDate(e.target.value)) {
					d = moment(e.target.value, "DD-MM-YYYY")
						.add(-1, "days")
						.format("DD-MM-YYYY")
					if (nextRef !== null) specialUpdate(d)
					else update("dateF", { target: { value: d } })
				} else {
					d = moment().format("DD-MM-YYYY")
					if (nextRef !== null) specialUpdate(d)
					else update("dateF", { target: { value: d } })
				}
				break
			default:
				e.preventDefault()
				let caretS = e.target.selectionStart
				let caretE = e.target.selectionEnd
				if (caretS !== caretE && caretS !== 0 && caretE !== 10) {
				} else if (caretS === caretE) {
					if (input.length === 2 && caretE === 1) {
						input += "-"
						e.target.value = input
					} else if (input.length === 3 && caretE === 2) {
						input = input.substring(0, 2) + "-" + input[2]
						e.target.value = input
					} else if (input.length === 5 && caretE === 4) {
						input += "-" + new Date().getFullYear()
						e.target.value = input
						if (nextRef !== null) nextRef.current.focus()
					} else if (input.length === 6 && caretE === 5) {
						input =
							input.substring(0, 5) +
							"-" +
							input[5] +
							new Date().getFullYear()
						e.target.value = input
						if (nextRef !== null) nextRef.current.focus()
					} else if (input.length > 10) {
					} else {
						input =
							e.target.value.substring(0, caretS) +
							e.key +
							e.target.value.substring(caretS)
						e.target.value = input
						e.target.setSelectionRange(caretS + 1, caretS + 1)
					}
				} else if (caretS === 0 && caretE === 10) {
					e.target.value = e.key
				} else if (input.length > 10) {
				} else {
					e.target.value = input
				}
				update(field, e)
		}
	} else {
		e.preventDefault()
	}
}

export function typeDateNoUpdate(e, nextRef = null, func = null) {
	let chars = [
		"Backspace",
		"Enter",
		"Delete",
		"ArrowLeft",
		"ArrowRight",
		"+",
		"-",
	]
	let dateFormat = /^[0-9]$/
	if (e.key.match(dateFormat) || chars.includes(e.key)) {
		let input = e.target.value
		if (e.key.match(dateFormat)) input += e.key
		switch (e.key) {
			case "Backspace":
			case "ArrowLeft":
			case "ArrowRight":
			case "Delete":
				break
			case "Enter":
				if (nextRef !== null) nextRef.current.focus()
				else if (func !== null) func()
				break
			case "+":
				e.preventDefault()
				if (isValidDate(e.target.value))
					return moment(e.target.value, "DD-MM-YYYY")
						.add(1, "days")
						.format("DD-MM-YYYY")
				else return moment().format("DD-MM-YYYY")
			case "-":
				e.preventDefault()
				if (isValidDate(e.target.value))
					return moment(e.target.value, "DD-MM-YYYY")
						.add(-1, "days")
						.format("DD-MM-YYYY")
				else return moment().format("DD-MM-YYYY")
			default:
				e.preventDefault()
				let caretS = e.target.selectionStart
				let caretE = e.target.selectionEnd
				if (caretS !== caretE && caretS !== 0 && caretE !== 10) {
				} else if (caretS === caretE) {
					if (input.length === 2 && caretE === 1) {
						input += "-"
						return input
					} else if (input.length === 3 && caretE === 2) {
						input = input.substring(0, 2) + "-" + input[2]
						return input
					} else if (input.length === 5 && caretE === 4) {
						input += "-" + new Date().getFullYear()
						return input
					} else if (input.length === 6 && caretE === 5) {
						input =
							input.substring(0, 5) +
							"-" +
							input[5] +
							new Date().getFullYear()
						return input
					} else if (input.length > 10) {
					} else {
						input =
							e.target.value.substring(0, caretS) +
							e.key +
							e.target.value.substring(caretS)
						return input
					}
				} else if (caretS === 0 && caretE === 10) {
					return e.key
				} else if (input.length > 10) {
				} else {
					return input
				}
		}
	}
}

export function typeDate(
	e,
	nextRef,
	update,
	field,
	index = null,
	search = null,
	goNext = true,
) {
	let chars = [
		"Backspace",
		"Enter",
		"Delete",
		"ArrowLeft",
		"ArrowRight",
		"+",
		"-",
	]
	let dateFormat = /^[0-9]$/
	if (e.key.match(dateFormat) || chars.includes(e.key)) {
		let input = e.target.value
		if (e.key.match(dateFormat)) input += e.key
		switch (e.key) {
			case "Backspace":
				break
			case "Enter":
				if (nextRef !== null && goNext) nextRef.current.focus()
				else if (search !== null) search()
				break
			case "ArrowLeft":
				break
			case "ArrowRight":
				break
			case "Delete":
				break
			case "+":
				e.preventDefault()
				let d
				if (isValidDate(e.target.value)) {
					d = moment(e.target.value, "DD-MM-YYYY")
						.add(1, "days")
						.format("DD-MM-YYYY")
				} else {
					d = moment().format("DD-MM-YYYY")
				}
				e.target.value = d
				if (index === null) {
					if (update !== null) update(field, e)
				} else {
					if (update !== null) update(field, e, index)
				}
				break
			case "-":
				e.preventDefault()
				let da
				if (isValidDate(e.target.value)) {
					da = moment(e.target.value, "DD-MM-YYYY")
						.add(-1, "days")
						.format("DD-MM-YYYY")
				} else {
					da = moment().format("DD-MM-YYYY")
				}
				e.target.value = da
				if (index === null) {
					if (update !== null) update(field, e)
				} else {
					if (update !== null) update(field, e, index)
				}
				break
			default:
				e.preventDefault()
				let caretS = e.target.selectionStart
				let caretE = e.target.selectionEnd
				if (caretS !== caretE && caretS !== 0 && caretE !== 10) {
				} else if (caretS === caretE) {
					if (input.length === 2 && caretE === 1) {
						input += "-"
						e.target.value = input
					} else if (input.length === 3 && caretE === 2) {
						input = input.substring(0, 2) + "-" + input[2]
						e.target.value = input
					} else if (input.length === 5 && caretE === 4) {
						input += "-" + new Date().getFullYear()
						e.target.value = input
						if (nextRef !== null) nextRef.current.focus()
					} else if (input.length === 6 && caretE === 5) {
						input =
							input.substring(0, 5) +
							"-" +
							input[5] +
							new Date().getFullYear()
						e.target.value = input
						if (nextRef !== null) nextRef.current.focus()
					} else if (input.length > 10) {
					} else {
						input =
							e.target.value.substring(0, caretS) +
							e.key +
							e.target.value.substring(caretS)
						e.target.value = input
						e.target.setSelectionRange(caretS + 1, caretS + 1)
					}
				} else if (caretS === 0 && caretE === 10) {
					e.target.value = e.key
				} else if (input.length > 10) {
				} else {
					e.target.value = input
				}
				if (index === null) {
					if (update !== null) update(field, e)
				} else {
					if (update !== null) update(field, e, index)
				}
		}
	} else {
		e.preventDefault()
	}
}

export function typeDateFull(e, nextRef, update, field, index = null) {
	let chars = [
		"Backspace",
		"Enter",
		"Delete",
		"ArrowLeft",
		"ArrowRight",
		"+",
		"-",
	]
	let dateFormat = /^[0-9]$/
	if (e.key.match(dateFormat) || chars.includes(e.key)) {
		let input = e.target.value
		if (e.key.match(dateFormat)) input += e.key
		switch (e.key) {
			case "Backspace":
				break
			case "Enter":
				if (nextRef !== null) nextRef.current.focus()
				break
			case "ArrowLeft":
				break
			case "ArrowRight":
				break
			case "Delete":
				break
			case "+":
				e.preventDefault()
				let d
				if (isValidDate(e.target.value)) {
					d = moment(e.target.value, "DD-MM-YYYY")
						.add(1, "days")
						.format("DD-MM-YYYY")
				} else {
					d = moment().format("DD-MM-YYYY")
				}
				e.target.value = d
				if (index === null) {
					if (update !== null) update(field, e)
				} else {
					if (update !== null) update(field, e, index)
				}
				break
			case "-":
				e.preventDefault()
				let da
				if (isValidDate(e.target.value)) {
					da = moment(e.target.value, "DD-MM-YYYY")
						.add(-1, "days")
						.format("DD-MM-YYYY")
				} else {
					da = moment().format("DD-MM-YYYY")
				}
				e.target.value = da
				if (index === null) {
					if (update !== null) update(field, e)
				} else {
					if (update !== null) update(field, e, index)
				}
				break
			default:
				e.preventDefault()
				let caretS = e.target.selectionStart
				let caretE = e.target.selectionEnd
				if (caretS !== caretE && caretS !== 0 && caretE !== 10) {
				} else if (caretS === caretE) {
					if (input.length === 2 && caretE === 1) {
						input += "-"
						e.target.value = input
					} else if (input.length === 3 && caretE === 2) {
						input = input.substring(0, 2) + "-" + input[2]
						e.target.value = input
					} else if (input.length === 5 && caretE === 4) {
						input += "-"
						e.target.value = input
					} else if (input.length === 6 && caretE === 5) {
						input = input.substring(0, 5) + "-" + input[5]
						e.target.value = input
					} else {
						input =
							e.target.value.substring(0, caretS) +
							e.key +
							e.target.value.substring(caretS)
						e.target.value = input
						e.target.setSelectionRange(caretS + 1, caretS + 1)
					}
				} else if (caretS === 0 && caretE === 10) {
					e.target.value = e.key
				} else if (input.length > 10) {
				} else {
					e.target.value = input
				}
				if (index === null) update(field, e)
				else update(field, e, index)
				if (
					e.target.value.length >= 10 &&
					index === null &&
					nextRef !== null
				)
					nextRef.current.focus()
		}
	} else {
		e.preventDefault()
	}
}

export function onFocusLostDate(field, value, update) {
	if (moment(value, "DD-MM-YYYY", true).isValid()) return
	else update(field, { target: { value: "" } })
}

export function onFocusLostHour(field, value, update) {
	if (moment(value, "kk:mm", true).isValid()) return
	else update(field, { target: { value: "" } })
}

// Revue 6 (As9) : adresse absente, null ou champs null / undefined → non
// valide (avant : `!== ""` laissait passer `{}` et `null`). Revue 15.10
// (M1, Jordan) : le N° est FACULTATIF (route cantonale, lieu-dit), comme sur
// la tablette depuis SvpMobile 3.11.1.
export const isAdresseValide = (adresse) =>
	!!(
		adresse &&
		adresse.rue &&
		adresse.code_postal &&
		adresse.localite &&
		adresse.pays
	)

export const getFormattedDate = () => {
	return moment().format("DD-MM-YYYY")
}

// "DD-MM-YYYY" -> "YYYY-MM-DD" (valeur pour <input type="date">) ; "" si invalide/vide
export const dateFrToISO = (s) => {
	const m = moment(s, "DD-MM-YYYY", true)
	return m.isValid() ? m.format("YYYY-MM-DD") : ""
}

// "YYYY-MM-DD" (sortie de <input type="date">) -> "DD-MM-YYYY" (format state/back) ; "" si invalide/vide
export const dateISOToFr = (s) => {
	const m = moment(s, "YYYY-MM-DD", true)
	return m.isValid() ? m.format("DD-MM-YYYY") : ""
}

export const createCalendar = (month, year) => {
	let firstDay = new Date(year, month).getDay()
	if (firstDay === 0) firstDay = 7
	let daysInMonth = 32 - new Date(year, month, 32).getDate()
	let listDivs = []
	let date = 1
	let dateNb = 1
	for (let i = 0; i < 6; i++) {
		let divs = []
		for (let j = 0; j < 7; j++) {
			if (date >= firstDay && dateNb <= daysInMonth) {
				divs.push(dateNb)
				dateNb++
			} else divs.push("")
			date++
		}
		listDivs.push(divs)
	}
	if (listDivs[5].join("") === "") return listDivs.slice(0, 5)
	return listDivs
}

export const normalizePhoto = (photo) => ({
	id: photo.id,
	name: photo.url.split("/").pop(),
	url: `${URL}${photo.url}`,
	file: null,
	uploaded: true,
})

export const getPhotoFromFile = (file) => ({
	id: `${Date.now()}_${Math.random()}`,
	name: file.name,
	url: window.URL.createObjectURL(file),
	file,
	uploaded: false,
})

export const normalizePdf = (pdf) => {
	if (pdf === null) return null
	return {
		id: pdf.id,
		name: pdf.url.split("/").pop(),
		url: `${URL}${pdf.url.replace(/^\//, "")}`,
		file: null,
		uploaded: true,
	}
}

export const getPdfFromFile = (file) => ({
	id: `${Date.now()}_${Math.random()}`,
	name: file.name,
	url: window.URL.createObjectURL(file),
	file,
	uploaded: false,
})

// Revue 8 (Al2) : jours RÉELS d'une restitution, MÊME règle que le serveur
// (location/jours.reels_calcules) — heure murale (changement d'heure
// ignoré), toute journée entamée compte : max(1, ceil(minutes / 1440)).
// 10:00 → J+3 10:00 = 3 (l'ancien « jours entiers + 1 » donnait 4 → 400).
export const joursReelsRestitution = (dateDebut, dateFin) => {
	const debut = moment.utc(dateDebut, "YYYY-MM-DD HH:mm", true)
	const fin = moment.utc(dateFin, "YYYY-MM-DD HH:mm", true)
	if (!debut.isValid() || !fin.isValid()) return 0
	return Math.max(1, Math.ceil(fin.diff(debut, "minutes") / 1440))
}

export const getNbDaysBetweenDatetimesUSA = (dateDebut, dateFin) => {
	const isValid =
		moment(dateDebut, "YYYY-MM-DD HH:mm", true).isValid() &&
		moment(dateFin, "YYYY-MM-DD HH:mm", true).isValid()

	if (isValid) {
		return (
			Math.abs(
				moment(dateDebut, "YYYY-MM-DD HH:mm").diff(
					moment(dateFin, "YYYY-MM-DD HH:mm"),
					"days",
				),
			) + 1
		)
	}
	return 0
}
